import React, { memo } from 'react';
import { useComponentTheme } from '@vmos2/design-system';
import { getAppType, getBaseRoute } from '@vmos2/core';
import map from 'lodash/map';
import get from 'lodash/get';
import concat from 'lodash/concat';
import take from 'lodash/take';

import { Menu } from './menu';
import { AppStatuses, AppStatusMap } from '../constants';

type Props = {
  storeUUID: string,
  storeName: string,
  storeAppStatus: boolean,
  isDeliveryAvailable: boolean,
  availableTodayMenus: [],
  availableFutureDayMenus: [],
  unavailableMenus: [],
  holidayHours?: []
};

export const Menus = memo(
  ({
    storeUUID,
    storeName,
    storeAppStatus,
    isDeliveryAvailable,
    availableTodayMenus,
    availableFutureDayMenus,
    unavailableMenus,
    holidayHours
  }: Props) => {
    const isOpat = getAppType() === 'opat';
    const isMenuStockAvailable = menu =>
      storeAppStatus !== AppStatuses.OFF_TODAY ? AppStatusMap[storeAppStatus] : !!menu.futureDayOrdering;

    const componentTheme = useComponentTheme(theme => theme.components['StoreSelection:StoreCard'], 'default');

    const menuOverviewPath = `${getBaseRoute()}.store.menu.overview`;

    const availableTodayMenu = isOpat ? take(availableTodayMenus, 1) : availableTodayMenus;
    const menuNameIsShown =
      (concat(availableTodayMenu, availableFutureDayMenus).length === 1 || isOpat) &&
      !get(componentTheme, 'MenuName.visible', true);

    return (
      <div data-test="menus-container">
        {map(availableTodayMenu, menu => (
          <Menu
            key={menu.uuid}
            menu={menu}
            isNameShown={!menuNameIsShown}
            storeUUID={storeUUID}
            storeName={storeName}
            isMenuStockAvailable={isMenuStockAvailable(menu)}
            isDeliveryAvailable={isDeliveryAvailable}
            menuOverviewPath={menuOverviewPath}
            holidayHours={holidayHours}
          />
        ))}
        {!isOpat &&
          map(availableFutureDayMenus, menu => (
            <Menu
              key={menu.uuid}
              menu={menu}
              isNameShown={!menuNameIsShown}
              isFutureDay
              storeUUID={storeUUID}
              storeName={storeName}
              isMenuStockAvailable={isMenuStockAvailable(menu)}
              isDeliveryAvailable={isDeliveryAvailable}
              menuOverviewPath={menuOverviewPath}
              holidayHours={holidayHours}
            />
          ))}
        {map(unavailableMenus, menu => (
          <Menu
            key={menu.uuid}
            menu={menu}
            isNameShown={!menuNameIsShown}
            storeUUID={storeUUID}
            storeName={storeName}
            isMenuStockAvailable={isMenuStockAvailable(menu)}
            isDeliveryAvailable={isDeliveryAvailable}
            menuOverviewPath={menuOverviewPath}
          />
        ))}
      </div>
    );
  }
);
